import React from 'react';
import Contact from '../../components/Contact/Contact';
import { Helmet } from 'react-helmet-async';

const ContactUs = () => {

    return (
        <>
            <Helmet>
                {/* Title */}
                <title>Speak With Our Financial Planning Team | Contact PFGS</title>

                {/* Meta Description */}
                <meta
                    name="description"
                    content="Have questions about financial planning or investments? Contact PFGS today via (02) 9476 8531 or email mandeep@pfgs.com.au to get expert advice."
                />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pfgs.com.au/contact" />

                {/* Meta Robots */}
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                />

                {/* Open Graph (Facebook / LinkedIn / WhatsApp) */}
                <meta property="og:title" content="Speak With Our Financial Planning Team | Contact PFGS" />
                <meta property="og:description" content="Have questions about financial planning or investments? Contact PFGS today via (02) 9476 8531 or email mandeep@pfgs.com.au to get expert advice." />
                <meta property="og:url" content="https://pfgs.com.au/contact" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://pfgs.com.au/pfgs-preview.jpg" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Speak With Our Financial Planning Team | Contact PFGS" />
                <meta name="twitter:description" content="Have questions about financial planning or investments? Contact PFGS today via (02) 9476 8531 or email mandeep@pfgs.com.au to get expert advice." />
                <meta name="twitter:image" content="https://pfgs.com.au/pfgs-preview.jpg" />
            </Helmet>
            <div className="home-page">
                <Contact />
            </div>
        </>
    );
};

export default ContactUs;
